import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Wallet() {
    const [agent, setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [extensions, setExtensions] = useState([])
    const [walletNo, setWalletno] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 20;
    const totalPages = Math.ceil(extensions.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentPolicies = extensions.slice(indexOfFirstRow, indexOfLastRow)
    const [monthStartMs, setMonthstartms] = useState(null)
    const[end,setEnd] = useState('');
    const[start,setStart] = useState('');
    const [balance, setBalance] = useState(0)
    const [modal, setModal] = useState(false)
    const [mobile, setMobile] = useState('')
    const [amount, setAmount] = useState(0)
    const [topupText, setTopuptext] = useState('TOP UP NOW')
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const company = 'Definite'

    useEffect(()=>{
    const getCredentials =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
    const data = await res.json();
    const {Username, Password} = data;
    const cred = btoa(`${Username}:${Password}`)
    setCredentials(btoa(`${Username}:${Password}`))
    setIsauth(true)


    }
    getCredentials()

    },[])

    const toggle=()=>{
        setModal(!modal)
    }

    const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setStart(millisecondsSinceEpoch);

        };
        const handleDateChange2 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setEnd(millisecondsSinceEpoch);
        
        };

    const exportTableToPDF = () => {
        const input = document.getElementById('policy-table');
        
        // Optional: Add a temporary title to the table before capturing
        const title = document.createElement('h2');
        title.textContent = `${currentMonthName} WALLET STATEMENT`;
        title.style.textAlign = 'center';
        title.style.color = '#2c3e50';

        title.style.marginBottom = '20px';
        input.parentNode.insertBefore(title, input); // Insert title above table
        
        // Color the header row (if not already styled)
        const headerRow = input.querySelector('thead tr');
        headerRow.style.backgroundColor = 'green'; // Dark gray
        headerRow.style.color = 'white';
        
        html2canvas(input, {
            scale: 2, // Higher quality
            logging: false, // Disable console logs
            useCORS: true, // Handle external resources
            allowTaint: true, // Allow external images
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            
            // Margins (10mm on all sides)
            const margin = 10;
            const imgWidth = 210 - margin * 2; // A4 width minus margins
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            
            // Add title text directly to PDF (alternative approach)
            pdf.setFontSize(19);
            pdf.setTextColor(44, 62, 80); // #2c3e50
            pdf.text(`${currentMonthName} WALLET STATEMENT`, 105, margin, { align: 'center' }); // Centered
            
            // Add table image with margins
            pdf.addImage(
            imgData, 
            'PNG', 
            margin, 
            margin + 10, // Extra space below title
            imgWidth, 
            imgHeight
            );
        
            pdf.save('wallet_statement.pdf');
            
            // Clean up: Remove temporary title and header styling
            title.remove();
            headerRow.style.backgroundColor = '';
            headerRow.style.color = '';
        });
        };

    const getMonthName = (input) => {
        const date = input ? new Date(input) : new Date();
        return date.toLocaleString('default', { month: 'long' });
        };
        const currentMonthName = getMonthName(); // No argument → current month
        const customDate = new Date(2025, 7, 11).getTime(); // August 11, 2025 (in ms)
        const augustName = getMonthName(customDate); // "August"


    useEffect(() => {
        setMonthstartms(getCurrentMonthStartInMilliseconds())
    const user = localStorage.getItem('definiteagent'); // Retrieve email
    if (user) {
        
        setAgent(user)
    } else {

    }
    }, []);

    useEffect(()=>{
        const getAgentcode =async()=>{
            const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                  method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setAgentcode(data.OID)   

        }
        if(agent && isAuth){
            getAgentcode()
        }
    },[agent,isAuth])

    useEffect(()=>{
       

        const getWallet =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWallet?agent=${agentCode}`,{
                  method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setWalletno(data.WalletNo)

        }

        if(agentCode && isAuth){
          
            getWallet()
        }

    },[agentCode,isAuth])

    useEffect(()=>{
        const getWalletstatements =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWalletstatement?wallet=${walletNo}`,{
                  method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setExtensions(data)
        }
         const getWalletbalance =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWalletbalance?wallet=${walletNo}`,{
                  method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            if(data.Balance == 0){
                setBalance(0)
            }
            else{
                 setBalance(data.Balance)
            }
           
        }

        if(walletNo && isAuth){
            getWalletstatements()
            getWalletbalance()
        }
    },[walletNo, isAuth])

     const getWalletstatements =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWalletstatement?wallet=${walletNo}`,{
                  method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setExtensions(data)
        }
    const getWalletbalance =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWalletbalance?wallet=${walletNo}`,{
          method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
    })
    const data = await res.json();
    setBalance(data.Balance)
    }




    function formateDateISO(input){
        if(typeof input === 'string'){
            return input.split('T')[0]
        }
        else if (input instanceof Date){
            return input.toISOString().split('T')[0]
        }

        throw new Error('Invalid input: Expected ISO String or Date Object')
    }
    function formatDateToMilliseconds(input) {
        if (typeof input === 'string') {
            // For ISO string, create Date object and get time
            return new Date(input).getTime();
        }
        else if (input instanceof Date) {
            // For Date object, directly get time
            return input.getTime();
        }
        
        throw new Error('Invalid input: Expected ISO String or Date Object');
    }



    function formatter(amount) {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }

        const getCurrentMonthStartInMilliseconds = () => {
        const now = new Date();
        const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        return firstDayOfMonth.getTime();
        };

    const totalCommission = currentPolicies.reduce(
    (sum, policy) => sum + (policy.GrossCommission || 0),
    0
    )

    const topup =async()=>{
        // if(mobile && amount){
        //     // setTopuptext('Please wait....')
        //     // toast.success('Prompt sent to you phone')
        //     const formattedNumber2 ="254" + mobile.slice(1);
        //     const bal = parseInt(balance)+parseInt(amount)
        //     // const res = await fetch('https://sms.definiteassurance.com/webhook/f64bb81c-6ec7-43bd-923d-3596d56659ad',{

        //     // })
        //     const res = await Axios.post('https://workflows.uuidesign.xyz/webhook-test/f64bb81c-6ec7-43bd-923d-3596d56659ad',{amount,phone:formattedNumber2,walletNo,bal})
        //     if(res.data.success){
        //         setTopuptext('TOPUP NOW')
        //        toast.success('Topup successfull')
        //        getWalletbalance();
        //        getWalletstatements();
        //        setModal(false)
                
        //     }
        //     else{
        //         setTopuptext('TOPUP NOW')
        //          toast.error('Payment not received!')

        //     }
        //     toast.error('Unable to connect to server')

        // }

        toast.error('Disabled! Contact support!')
    }
  return (
    <div>
        <div className="page-content">
                    <ToastContainer />
                <Breadcrumbs title="Definite Assurance" breadcrumbItem={`MY WALLET`} />
                <Card className="mini-stats-wid">
                    <CardBody>
                        <h4>Wallet Balance: Kes. {balance}</h4>
                       
                        <hr />
                        <div className="walletButtons">
                            <Button color="info" onClick={toggle}>Topup Wallet</Button>
                              <button 
                                onClick={exportTableToPDF}
                                style={{ 
                                    padding: '8px 16px',
                                    background: 'rgb(0, 96, 66)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                                >
                        Export to PDF
                        </button>

                        </div>
                      
                            <div className="table-responsive" style={{padding:'10px'}}>
        
        
                        <Table striped bordered hover id="policy-table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Date Done</th>
                            <th scope="col">Transaction type</th>     
                            <th scope="col">Amount(KES)</th>
                            <th scope="col">Balance(KES)</th>
                            <th scope="col">Purpose</th>

        
                            </tr>
                        </thead>
                        <tbody>
                            {currentPolicies.map((val, index) => {
                            // Calculate the correct index based on current page
                            const globalIndex = indexOfFirstRow + index;
                            const transactionDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.DateDone)
                                    return (
                                        <tr key={val.OID}>
                                        <td>{index + 1}</td>
                                        <td>{transactionDate}</td>
                                        {val.TransactionType == 1 &&
                                            <td>DEPOSIT</td>
                                        }
                                         {val.TransactionType == 0 &&
                                            <td>PREMIUM PAYMENT</td>
                                        }

                                        <td>{formatter(parseInt(val.Amount))}</td>

                                        <td>{formatter(parseInt(val.Balance))}</td>
                                        
                                        <td>{val.Purpose}</td>
                                        </tr>
                                    );
  
                            })}
                        </tbody>
                        </Table>
        
                        {/* Pagination controls */}
                        <div className="d-flex justify-content-between align-items-center">
                        <div>
                            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, extensions.length)} of {extensions.length} entries
                        </div>
                        <div>
                            <button 
                            className="btn btn-sm btn-outline-primary mx-1"
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            >
                            Previous
                            </button>
                            
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                            <button
                                key={page}
                                className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => setCurrentPage(page)}
                            >
                                {page}
                            </button>
                            ))}
                            
                            <button 
                            className="btn btn-sm btn-outline-primary mx-1"
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            >
                            Next
                            </button>
                        </div>
                        </div>
                        </div>
                        
                    </CardBody>
                </Card>
                </div>

    <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>TOP UP ACCOUNT</ModalHeader>
        <div className="modalContainer">
            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="MPESA NUMBER*" onChange={(e)=>{setMobile(e.target.value)}}>
                <Form.Control  className='inputSearch' value={mobile}  type="text" placeholder="MPESA NUMBER" />
            </FloatingLabel>
            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="AMOUNT*" onChange={(e)=>{setAmount(e.target.value)}}>
                <Form.Control  className='inputSearch' value={amount}  type="text" placeholder="AMOUNT" />
            </FloatingLabel>
             <Button color="success" className="quoteButton2" onClick={topup}>{topupText}</Button>
            {/* <p style={{textAlign:'center',marginTop:'4%',marginBottom:'2%'}}>___________OR__________</p>
            <div className="mpesaSteps">
                <p>1. GO TO  MPESA TOOLKIT</p>
                <p>2. SELECT LIPA NA MPESA</p>
                <p>3. SELECT PAYBILL</p>
                <p>4. ENTER PAYBILL NUMBER <strong>400200</strong></p>
                <p>5. ENTER ACCOUNT <strong>{walletNo}</strong></p>
                <p>6. ENTER MPESA PIN AND COMPLETE</p>
            </div> */}
        </div>
    </Modal>
    </div>
  )
}
